import _ from 'lodash';
import { z } from 'zod';

export const fileSchemaOptional = z
  .array(z.any())
  .optional()
  .refine(
    files => {
      if ((files ?? []).length > 0) {
        for (const file of files ?? []) {
          if (file instanceof File) {
            const max = 2 * 1024 * 1024; // 2MB
            return file.size <= max;
          }

          if (_.isObject(file)) {
            return true;
          }

          return false;
        }
      }

      return true;
    },
    { message: 'Attachment size must be less than 2MB' },
  );

export const fileSchema = z
  .array(z.any())
  .refine(files => !_.isEmpty(files), 'Attachment is Required')
  .refine(
    files => {
      for (const file of files) {
        if (file instanceof File) {
          const max = 2 * 1024 * 1024; // 2MB
          return file.size <= max;
        }

        if (_.isObject(file)) {
          return true;
        }

        return false;
      }
    },
    { message: 'Attachment size must be less than 2MB' },
  );
